export default __webpack_public_path__ + "static/media/logo-white.eac62820.svg";